import { Crown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function PremiumName({ user }: { user: { username: string; premium?: boolean } }) {
  const { t } = useTranslation('premium');
  return (
    <span className={user.premium ? 'premium-name' : undefined}>
      {user.username}
      {user.premium && <><Crown size={15} aria-hidden="true" /><span className="visually-hidden"> — {t('memberBadge')}</span></>}
    </span>
  );
}
